class AudioPlayer {
    constructor(playlist) {
        // assign playlist data
        this.playlist = playlist;

        // initial index value
        this.playlistIndex = -1;

        this.player = document.createElement("video");
        this.player.preload = "auto";
        this.player.muted = true;
        this.player.loop = true;
        document.body.querySelector('#preview-container').appendChild(this.player);
    }

    start() {
        this.switchTrack(); // start playback
    }

    switchTrack(){
        var nextPlaylistIndex = this.nextIndex();       // next loaded content
        console.log("Entering switch track. Playlist indexes: " + this.playlistIndex + " => " + nextPlaylistIndex);
        this.playlistIndex = nextPlaylistIndex;
        const nextContent = this.playlist[nextPlaylistIndex];

        try {
            console.log("Start playback " + nextContent.name);
            this.player.pause();
            this.player.src = nextContent.content;
            this.player.load();
            this.player.play();

            setTimeout(this.switchTrack.bind(this), nextContent.duration * 1000);
        } catch (e) {
            console.error("AudioPlayer switchTrack error: " + e.message);
        }
    }

    nextIndex() {
        // increment counter
        let index = this.playlistIndex + 1;
        return (index === this.playlist.length) ? 0 : index;
    }
}
